import React from "react";
import { TableContentForEmployeeImageReportSundry } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {

    render() {

        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const tableHeaders = this.props.tableHeaders;

        return (
            <div style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto' }} >

                <div style={{ width: '100%' }}>
                    <h3><center><u>Employee Image Report Sundry</u></center></h3>
                    <div className="row pb-4 pt-4 pl-2">
                        <div className="col"><b>Group: </b> {searchData.group}</div>
                        <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
                        <div className="col"><b>Collection Point: </b> {searchData.division}</div>
                        <div className="col"><b>Date: </b> {searchData.date}</div>
                    </div>
                    <center>
                        <div style={{ width: '100%' }} >
                            <div style={{ width: '100%' }}  >
                                <div style={{ width: '100%' }} >
                                    <div style={{ marginLeft: 'auto', marginRight: 'auto', width: '80%' }}>
                                        <center>
                                            <table className="display dataTable no-footer" style={{ width: "100%" }}>
                                                <thead>
                                                    <tr>
                                                        {
                                                            tableHeaders.map((x, index) => {
                                                                return (
                                                                    <th key={index}>{x}</th>
                                                                );
                                                            })
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContentForEmployeeImageReportSundry
                                                        data={reportData}
                                                        contentRowNames={contentRowNames}
                                                        hasEdit={false}
                                                    />
                                                </tbody>
                                            </table>
                                        </center>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </center>
                </div>

            </div>
        );
    }
}